import * as ko from 'knockout';
import td_checkboxHtml from './td-checkbox.html?raw';

export const template = td_checkboxHtml;

export interface IItemCheckbox {
    toggle: () => void
    isChecked: () => boolean
    show: () => boolean
    isEnabled?: () => boolean
    getTitle?: () => string | number | null
}

export class viewModel {
    readonly tooltip: KnockoutComputed<string | number | null>;

    constructor(private obj: IItemCheckbox) {
        this.tooltip = ko.pureComputed((): string | number | null => {
            if (!(this.obj.isEnabled?.() ?? true)) {
                return this.obj.getTitle?.() ?? null;
            }
            return this.obj.isChecked() ? 'remove' : 'add';
        });
    }

    isEnabled = (): boolean => this.obj.isEnabled?.() ?? true;

    onClick = (): void => {
        if (this.isEnabled()) {
            this.obj.toggle();
        }
    };
}